// ── 직원 등록·수정 창 아래쪽 칸 — 연락처·gmail·생년월일·입사/퇴사일자·연차 시작 차수·주소·계좌·메모·안내문 ──────
// 2026-11-03 UserModals.jsx(289줄)에서 그대로 옮겼다(300줄 규칙, 동작 변화 없음) — 등록 창 맨 위 '구분(4대보험/3.3%)' 칸을 넣기 전 정리.
import React from 'react';
import UserEffectiveHistoryFields from './UserEffectiveHistoryFields';
import { btn, inputStyle, helperTextStyle, gmailSuffixStyle } from './styles';
import { dateLabelStyle } from './userModalStyles';
import { isNoId, formatPhone, onlyDigits } from './utils';

export default function UserDetailFields({ form, setForm, editing, openAddressSearch }) {
  return (
    <>
      <input
        style={inputStyle}
        placeholder="연락처 010-0000-0000"
        value={form.phone}
        maxLength={13}
        onChange={(e) => setForm({ ...form, phone: formatPhone(e.target.value) })}
      />
      <div style={{ position: 'relative' }}>
        <input
          style={{ ...inputStyle, width: '100%', paddingRight: 92 }}
          placeholder="gmail 아이디"
          value={form.emailId}
          maxLength={60}
          onChange={(e) => setForm({ ...form, emailId: e.target.value.replace(/[^a-zA-Z0-9._-]/g, '') })}
        />
        <span style={gmailSuffixStyle}>@gmail.com</span>
      </div>
      <input
        style={inputStyle}
        placeholder="생년월일 6자리"
        value={form.birth_date}
        maxLength={6}
        onChange={(e) => setForm({ ...form, birth_date: onlyDigits(e.target.value, 6) })}
      />
      {/* 입사·퇴사일자 — 칸 안쪽 라벨 (2026-08-27 사용자 명세: date 입력은 placeholder 불가) */}
      <div style={{ position: 'relative' }}>
        <span style={dateLabelStyle}>입사일자</span>
        <input
          style={{ ...inputStyle, width: '100%', boxSizing: 'border-box', paddingLeft: 76 }}
          type="date"
          value={form.hire_date}
          onChange={(e) => setForm({ ...form, hire_date: e.target.value })}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <span style={dateLabelStyle}>퇴사일자</span>
        <input
          style={{ ...inputStyle, width: '100%', boxSizing: 'border-box', paddingLeft: 76 }}
          type="date"
          value={form.resign_date}
          onChange={(e) => setForm({ ...form, resign_date: e.target.value })}
        />
      </div>
      <input
        style={inputStyle}
        type="number"
        step="1"
        min="0"
        placeholder="연차 시작 차수"
        value={form.first_year_grant_count}
        onChange={(e) => setForm({ ...form, first_year_grant_count: e.target.value })}
      />
      <div style={{ gridColumn: '1 / -1', display: 'grid', gap: 8 }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            style={{ ...inputStyle, flex: 1 }}
            placeholder="주소"
            value={form.addressBase}
            onChange={(e) => setForm({ ...form, addressBase: e.target.value })}
          />
          <button type="button" style={btn} onClick={openAddressSearch}>주소검색</button>
        </div>
        <input
          style={inputStyle}
          placeholder="상세주소"
          value={form.addressDetail}
          onChange={(e) => setForm({ ...form, addressDetail: e.target.value })}
        />
      </div>
      <input
        style={inputStyle}
        placeholder="은행명"
        value={form.bank_name}
        onChange={(e) => setForm({ ...form, bank_name: e.target.value })}
      />
      <input
        style={inputStyle}
        placeholder="계좌번호(숫자만)"
        value={form.bank_account}
        onChange={(e) => setForm({ ...form, bank_account: onlyDigits(e.target.value, 30) })}
      />
      <UserEffectiveHistoryFields
        kind="bank"
        editing={editing}
        form={form}
        setForm={setForm}
      />
      <textarea
        style={{ ...inputStyle, gridColumn: '1 / -1', minHeight: 74 }}
        placeholder="메모"
        value={form.memo}
        onChange={(e) => setForm({ ...form, memo: e.target.value })}
      />
      {/* 하단 안내문 — 3줄 고정 정렬 (2026-08-27 사용자 명세) */}
      <div style={{ ...helperTextStyle, display: 'grid', gap: 3 }}>
        {!editing && (
          <>
            <span>아이디를 비우면 아이디 없음으로 등록되고, 수정 화면에서 나중에 설정할 수 있습니다.</span>
            <span>초기 비밀번호는 0214입니다.</span>
          </>
        )}
        {editing && isNoId(editing.user_id) && (
          <span>현재 아이디 없음 상태입니다. 이번 수정에서 최초 1회 아이디를 설정할 수 있습니다.</span>
        )}
        <span>기본은 입사 1년 미만 연차 정책입니다. 시작 차수 예시: 1=첫 지급 15, 2=첫 지급 15 다음 달 16.</span>
      </div>
    </>
  );
}
